import React from "react";
import PathConstants from "./pathConstants";

const SuccessPage = React.lazy(() => import("pages/payments/SuccessPage"));
const FailurePage = React.lazy(() => import("pages/payments/FailurePage"));
const NotFound = React.lazy(() => import("pages/error.pages/NotFound"));
const HomePage = React.lazy(() => import("pages/home/HomePage"));
const UnderMaintenance = React.lazy(() =>
  import("pages/error.pages/UnderMaintenance")
);

export const noLayoutRoutes = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: PathConstants.UNDER_MAINTENANCE,
    element: <UnderMaintenance />,
  },
  {
    path: PathConstants.PAYMENT,
    children: [
      {
        path: PathConstants.PAYMENT_SUCCESS,
        element: <SuccessPage />,
      },
      {
        path: PathConstants.PAYMENT_FAILURE,
        element: <FailurePage />,
      },
    ],
  },
  { path: PathConstants.NOT_FOUND, element: <NotFound /> },
];
